//
//
//
//
//
//
//
//
//


import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    };
  },
  components: {
  },
  watch: {

  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/App.vue